import { Control } from "react-hook-form";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Box from "@mui/material/Box";

import SelectFormField from "components/select-form-field";
import { PHONE_TYPES } from "constants/patients";

import { PatientFormValues } from "../patient-form.component";

type PhoneTypeFieldProps = {
  control: Control<PatientFormValues, object>;
};

export default function PhoneTypeField({ control }: PhoneTypeFieldProps) {
  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      <AccountCircleOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} color="action" />
      <SelectFormField
        name="phone_type"
        label="Type of Phone number"
        control={control}
        options={PHONE_TYPES.getOptions()}
        required
      />
    </Box>
  );
}
